"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * par defaut un bouton type='submit' (car rien de précisé sur la directive). Mettre type='button' pour un bouton qui ne doit pas submiter.<br/>
 * ex :
 *<pre>{@code
 *  <tl-button type="button" class="btn-primary " ng-click="add()">Ajouter</tl-button>
 *}</pre>
 */
ngModule.directive("tlButton", function (uiUtils, $mdButtonInkRipple) {
  return {
    restrict: "E",
    transclude: true,
    replace: true,
    template: function template(element, attrs) {
      return uiUtils.isAnchor(attrs) ? '<a class="btn" ng-transclude></a>' : '<button class="btn" ng-transclude></button>';
    },
    link: function link($scope, $el, $attrs) {
      $mdButtonInkRipple.attach($scope, $el);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-button.js
// module id = 2922
// module chunks = 13